import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import contentAppearanceQuery, {
	type contentAppearanceQuery$data,
	type contentAppearanceQuery$variables,
} from './__generated__/contentAppearanceQuery.graphql.ts';

export const preloadDraftContentAppearance = (
	contentId: contentAppearanceQuery$variables['contentId'],
	useCache: boolean = true,
) => {
	return query<
		contentAppearanceQuery$data,
		contentAppearanceQuery$variables & { cacheBuster?: number }
	>({
		query: contentAppearanceQuery,
		variables: {
			contentId,
			status: ['current', 'draft'],
			...(!useCache ? { cacheBuster: Date.now() } : {}),
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
};
